import React, { useState } from 'react';
import { API_BASE_URL } from './config';
import './styles/Login.css';

export function ChangePassword({ usuarioId, onPasswordChangeSuccess, onCancel }) {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [requirements, setRequirements] = useState({
        length: false,
        uppercase: false,
        special: false
    });

    const validatePasswordLocal = (pass) => {
        setRequirements({
            length: pass.length >= 8,
            uppercase: /[A-Z]/.test(pass),
            special: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>/?]/.test(pass)
        });
    };

    const handlePasswordChange = (e) => {
        const val = e.target.value;
        setPassword(val);
        validatePasswordLocal(val);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (password !== confirmPassword) {
            setError('Las contraseñas no coinciden');
            return;
        }

        if (!requirements.length || !requirements.uppercase || !requirements.special) {
            setError('La contraseña no cumple con todos los requisitos');
            return;
        }

        setLoading(true);
        setError('');

        try {
            const response = await fetch(`${API_BASE_URL}/api/auth/change-temporary-password`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ usuarioId, nuevaContrasena: password }),
            });

            const data = await response.json();

            if (response.ok && data.success) {
                // Después de cambiar la clave, volvemos al login o pedimos que inicie sesión
                // Para simplificar, le pedimos que vuelva al login con su nueva clave
                alert('Contraseña actualizada con éxito. Por favor inicia sesión con tu nueva contraseña.');
                onPasswordChangeSuccess();
            } else {
                setError(data.error || 'Error al actualizar la contraseña');
            }
        } catch (err) {
            setError('Error de conexión con el servidor');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <div className="login-box" style={{ maxWidth: '450px' }}>
                <h1>Actualizar Contraseña</h1>
                <p style={{ textAlign: 'center', color: '#64748b', marginBottom: '24px' }}>
                    Por seguridad, debes cambiar tu contraseña provisoria antes de continuar.
                </p>

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="password">Nueva Contraseña:</label>
                        <input
                            type="password"
                            id="password"
                            value={password}
                            onChange={handlePasswordChange}
                            required
                            disabled={loading}
                            placeholder="••••••••"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="confirmPassword">Confirmar Contraseña:</label>
                        <input
                            type="password"
                            id="confirmPassword"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                            disabled={loading}
                            placeholder="••••••••"
                        />
                    </div>

                    <div className="password-requirements" style={{
                        margin: '16px 0',
                        padding: '12px',
                        backgroundColor: '#f8fafc',
                        borderRadius: '8px',
                        fontSize: '0.8rem'
                    }}>
                        <p style={{ fontWeight: '600', marginBottom: '8px', color: '#475569' }}>La contraseña debe tener:</p>
                        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                            <li style={{ color: requirements.length ? '#10b981' : '#94a3b8', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                {requirements.length ? '✅' : '○'} Mínimo 8 caracteres
                            </li>
                            <li style={{ color: requirements.uppercase ? '#10b981' : '#94a3b8', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                {requirements.uppercase ? '✅' : '○'} Al menos una mayúscula
                            </li>
                            <li style={{ color: requirements.special ? '#10b981' : '#94a3b8', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                {requirements.special ? '✅' : '○'} Al menos un carácter especial
                            </li>
                        </ul>
                    </div>

                    {error && <div className="error-message">{error}</div>}

                    <button
                        type="submit"
                        disabled={loading || !requirements.length || !requirements.uppercase || !requirements.special}
                        className="login-button"
                    >
                        {loading ? 'Actualizando...' : 'Cambiar Contraseña'}
                    </button>

                    <button
                        type="button"
                        onClick={onCancel}
                        style={{
                            marginTop: '16px',
                            background: 'none',
                            border: 'none',
                            color: '#94a3b8',
                            cursor: 'pointer',
                            fontSize: '0.875rem',
                            width: '100%'
                        }}
                    >
                        ← Volver al Login
                    </button>
                </form>
            </div>
        </div>
    );
}
